const uiIcons = Object.freeze({
  addCircle: 'addCircle',
  check: 'check',
  chevronDown: 'chevronDown',
  chevronUp: 'chevronUp',
  home: 'home',
  info: 'info',
  lock: 'lock',
  mail: 'mail',
  person: 'person',
  refresh: 'refresh',
  search: 'search',
  warning: 'warning'
});

export default uiIcons;
